import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraBadge } from '../ensigns/badge';
import { SpecraStatusDot } from '../ensigns/status-dot';
/** Semantic status label with the compact dot treatment used throughout Delivery. */ export function SpecraStatusPill({ children, className, dot = true, status, tone: toneProp, ...props }) {
    const tone = status ?? toneProp ?? 'neutral';
    return /*#__PURE__*/ _jsxs(SpecraBadge, {
        className: cn('rounded-[var(--radius-badge)] border-0 px-[var(--space-2)] py-[var(--space-status-y)] text-[length:var(--fs-ui-label)] uppercase tracking-[var(--ls-ui-label)]', className),
        variant: tone,
        ...props,
        children: [
            dot ? /*#__PURE__*/ _jsx(SpecraStatusDot, {
                tone: tone
            }) : null,
            children
        ]
    });
}
